var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"animate__animated animate__fadeIn"},[_c('Loader',{attrs:{"loading":_vm.isLoading}}),_c('Header',{attrs:{"business":_vm.business}}),_c('ComplaintForm',{attrs:{"business":_vm.business}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }